import PropTypes from 'prop-types';

import css from '@/src/authentication/signIn/styles/singIn.module.css';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import AuthenticationLayout from '../../authenticationLayout/componetns/AuthantificationLayout';
import AuthenticationTitles from '../../authenticationTiltes/components/AuthenticationTitles';
import ForgotPasswordForm from './ForgotPasswordForm';

interface IForgotPasswordLayoutProps {
  handleSubmit: (...args: any) => any;
  isLoading: boolean;
}

const ForgotPasswordLayout = ({
  handleSubmit,
  isLoading,
}: IForgotPasswordLayoutProps) => {
  return (
    <AuthenticationLayout withSignUpButton={true}>
      <div className={css.mainWrapper}>
        <AuthenticationTitles
          mainTitle={<TextLocal id={'forgot-password.forgot-your-password'} />}
          subTitle={<TextLocal id={'forgot-password.reset-password-by'} />}
        />
        <ForgotPasswordForm handleSubmit={handleSubmit} isLoading={isLoading} />
      </div>
    </AuthenticationLayout>
  );
};

ForgotPasswordLayout.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ForgotPasswordLayout;
